// src/features/projectsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const myTasksSlice = createSlice({
  name: 'myTasks',
  initialState: {
    list: [],
    status: 'idle',
    error: null
  },
  reducers: {
    setMyTasks: (state, action) => {
      console.log('Setting projects in slice:', action.payload);
      state.list = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    clearMyTasks: (state) => {
      state.list = [];
      state.status = 'idle';
      state.error = null;
    }
  }
});

export const { setMyTasks, setError, clearMyTasks } = myTasksSlice.actions;

export const selectAllProjects = (state) => {
  console.log('Selecting projects:', state.projects.list);
  return state.myTasks.list;
};
export const selectProjectsStatus = (state) => state.myTasks.status;
export const selectProjectsError = (state) => state.myTasks.error;

export default myTasksSlice.reducer;